import { atom } from "recoil";

export type TActiveTab =
  | "confirmContractContent"
  | "sendContractForm"
  | "confirmRequestSign"
  | "createContract"
  | "uploadContract"
  | "confirmContract";

export const activeTabAtom = atom<TActiveTab>({
  key: "activeTabAtom",
  default: "confirmContractContent",
});

export const fileContractAtom = atom<string | undefined>({
  key: "fileContractAtom",
  default: "",
});
